import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { ActionButtonModule } from '../../../../shared/components/action-button';
import { DropdownModule } from '../../../../shared/components/dropdown/dropdown.module';
import { CatalogSortComponent } from './catalog-sort.component';

@NgModule({
  imports: [CommonModule, NzIconModule, I18nModule, DropdownModule, ActionButtonModule, NgbTooltipModule, ReactiveFormsModule],
  declarations: [CatalogSortComponent],
  exports: [CatalogSortComponent],
})
export class CatalogSortModule {}
